import { AxiosResponse } from 'axios'
import {
  ApiTokenViewModel,
  Guid,
  ApiTokenConfigurationViewModel,
  CreateApiTokenViewModel,
  UpgradeApiTokenViewModel,
} from '../api'
import { useApiClient } from './useApiClient'

export const useApiTokenApi = () => {
  const apiClient = useApiClient()

  const createApiToken = (
    supportUserId: string | null,
    data: CreateApiTokenViewModel,
  ) => {
    const supportUserPathPart =
      supportUserId === null ? '' : `user/${supportUserId}/`
    return apiClient.request<void, AxiosResponse<ApiTokenViewModel>>({
      url: `api/${supportUserPathPart}apiToken`,
      method: 'post',
      data,
      withCredentials: true,
    })
  }

  const upgradeApiToken = (
    apiTokenId: string,
    supportUserId: string | null,
    data: UpgradeApiTokenViewModel,
  ) => {
    const supportUserPathPart =
      supportUserId === null ? '' : `user/${supportUserId}/`
    return apiClient.request<void, AxiosResponse<ApiTokenViewModel>>({
      url: `api/${supportUserPathPart}apiToken/${apiTokenId}/upgrade`,
      method: 'post',
      data,
      withCredentials: true,
    })
  }

  const getApiTokens = (supportUserId: string | null) => {
    const supportUserPathPart =
      supportUserId === null ? '' : `user/${supportUserId}/`
    return apiClient.request<void, AxiosResponse<ApiTokenViewModel[]>>({
      url: `api/${supportUserPathPart}apiToken`,
      method: 'get',
      withCredentials: true,
    })
  }

  const getApiTokenConfiguration = () => {
    return apiClient.request<
      void,
      AxiosResponse<ApiTokenConfigurationViewModel>
    >({
      url: 'api/apiToken/config',
      method: 'get',
      withCredentials: true,
    })
  }

  const revokeApiToken = (supportUserId: string | null, apiTokenId: Guid) => {
    const supportUserPathPart =
      supportUserId === null ? '' : `user/${supportUserId}/`
    return apiClient.request<void, AxiosResponse<void>>({
      url: `api/${supportUserPathPart}apiToken/${apiTokenId}`,
      method: 'delete',
      withCredentials: true,
    })
  }

  return {
    getApiTokens,
    createApiToken,
    revokeApiToken,
    getApiTokenConfiguration,
    upgradeApiToken,
  }
}
